import reducer from "./apiReducers";

export default reducer;
